import * as React from "react";

const Input = React.forwardRef(({ style, type = "text", ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      style={{
        display: "flex",
        height: "2.5rem", // 10 * 0.25rem
        width: "100%",
        borderRadius: "0.375rem",
        border: "1px solid #D1D5DB",
        backgroundColor: "#FFFFFF",
        padding: "0.5rem 0.75rem",
        fontSize: "1rem",
        color: "#111827",
        outline: "none",
        boxSizing: "border-box",
        ...style, // allow overriding styles via props
      }}
      {...props}
    />
  );
});

Input.displayName = "Input";

export { Input };
